import ContentLoader from 'react-content-loader';
import styled from 'styled-components';

export const ChartAssetCardsWrapper = styled.div`
  gap: 1.3rem;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  ${({ theme }) => theme.media.laptop`
      display: flex;
  `};
`;

export const BodyLoader = styled(ContentLoader)`
  height: 10.5rem;
  max-width: 15.5rem;
  background-color: ${({ theme }) => theme.colors.text.interactive};
  border-radius: ${({ theme }) => theme.borderRadius.high};

  ${({ theme }) => theme.media.laptop`
      height: 9.8rem;
      width: 16rem;
  `};
`;

export const Percentage = styled.rect`
  width: 12rem;
  height: 2.3rem;

  x: 2.2rem;
  y: 2.4rem;

  rx: ${({ theme }) => theme.borderRadius.medium};
  ry: ${({ theme }) => theme.borderRadius.medium};
`;

export const AssetName = styled.rect`
  height: 1.8rem;
  width: 6rem;

  x: 6.4rem;
  y: 5.8rem;

  rx: ${({ theme }) => theme.borderRadius.medium};
  ry: ${({ theme }) => theme.borderRadius.medium};
`;

export const Color = styled.rect`
  height: 2rem;
  width: 2rem;

  x: 3.6rem;
  y: 5.8rem;

  rx: ${({ theme }) => theme.borderRadius.medium};
  ry: ${({ theme }) => theme.borderRadius.medium};
`;
